import React from 'react';
import PropTypes from 'prop-types';
import { RenderCheckBoxField } from '@zola/zola-ui';
import includes from 'lodash/includes';

import './ChecklistFilterMenuDesktop.less';
import { getChecklistFiltersGrouped } from '../../helpers';

const options = getChecklistFiltersGrouped();

const ChecklistFilterMenuDesktop = ({ selectedValues, toggleFilter }) => (
  <div className="checklist__filterDesktop--container">
    {Object.keys(options).map(filterGroup => (
      <div className="checklist__filterDesktop--group" key={filterGroup}>
        {filterGroup !== 'undefined' && <span className="checklist__desktopMenuFilter--title">{filterGroup}</span>}
        <ul>
          {options[filterGroup].map(option => (
            <li key={option.value}>
              <RenderCheckBoxField
                className="checklist__filterDesktop--label"
                type="checkbox"
                label={option.label}
                id={`checklist-${option.value}`}
                name={`checklist-${option.value}`}
                input={{
                  checked: includes(selectedValues, option.value),
                  onChange: () => toggleFilter(option.value),
                }}
                meta={{}}
              />
            </li>
          ))}
        </ul>
      </div>
    ))}
  </div>
);

ChecklistFilterMenuDesktop.propTypes = {
  selectedValues: PropTypes.arrayOf(PropTypes.string),
  toggleFilter: PropTypes.func,
};

ChecklistFilterMenuDesktop.defaultProps = {
  selectedValues: [],
};

export default ChecklistFilterMenuDesktop;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistFilterButton/ChecklistFilterMenuDesktop/ChecklistFilterMenuDesktop.jsx